import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { getAccountWsToken } from 'api/v1/account'
import { RootState } from '../index'

export const updateWsConnection = createAction<number>('ws/updateWsConnection')

export const getWsTokenAction = createAsyncThunk<
  string,
  undefined,
  {
    state: RootState
  }
>('ws/getWsTokenAction', async (_, { getState }) => {
  const state = getState()
  if (state.ws.token) {
    throw new Error('Ws token is exists')
  }
  const r = await getAccountWsToken()
  const { data } = r ?? {}
  const { result = '' } = data ?? {}
  return result
})

export const updateWsTokenAction = createAction<string>(
  'ws/updateWsTokenAction',
)

export const updatePingTimeAction = createAction<number>(
  'ws/updatePingTimeAction',
)
export const updatePongTimeAction = createAction<number>(
  'ws/updatePongTimeAction',
)
export const updateLatencyAction = createAction<number>(
  'ws/updateLatencyAction',
)

export const updateWsLostAction = createAction<number>('ws/updateWsLostAction')
